export const comments_3389025 = {"data":{"data":[],"links":{}}}